import { render, staticRenderFns } from "./cjzdpz.vue?vue&type=template&id=36c819b0&scoped=true&"
import script from "./cjzdpz.vue?vue&type=script&lang=js&"
export * from "./cjzdpz.vue?vue&type=script&lang=js&"
import style0 from "./cjzdpz.vue?vue&type=style&index=0&id=36c819b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c819b0",
  null
  
)

export default component.exports